/*
 * Hides the Intercom chat launcher while any of the theme's slide-in drawers,
 * modals or popovers (cart, filters, mobile menu, quick buy, the custom lab
 * report/Klaviyo slider panels, etc.) are open.
 *
 * Why: Intercom's launcher iframe renders at z-index 2147483000 (effectively
 * the maximum possible value), by design, so it always sits above page
 * content. No z-index we set on our own drawers can reliably out-rank that
 * without relying on an undocumented, ever-changing implementation detail —
 * so instead we use Intercom's own supported JS API (`hide_default_launcher`)
 * to hide it for as long as something of ours is open, then restore it.
 *
 * Native theme drawers/modals/popovers (cart-drawer, facets-drawer,
 * header-menu-drawer, quick-buy-modal, etc.) all extend the shared
 * `DialogElement` base class (assets/theme.js), which dispatches
 * "dialog:after-show" / "dialog:after-hide" on itself when it opens/closes.
 * Those events don't bubble, but capture-phase listeners on `document` still
 * see them (capture always walks root -> target regardless of bubbling).
 *
 * The hand-coded slider panel (snippets/soulhouse-slider-panel.liquid) is
 * not a DialogElement and doesn't dispatch those events, so it calls
 * window.shIntercomGuard.open()/close() directly instead.
 *
 * A counter (not a boolean) is used because more than one of these can be
 * open at once (e.g. a slider panel opened from within another drawer), so
 * the launcher should only reappear once everything is closed.
 *
 * Self-healing reset on load: `hide_default_launcher` is stored by Intercom
 * against the visitor's own session, not just as a page-local JS variable —
 * it survives navigation. If a visitor opens one of our panels and then
 * navigates away (clicks a link, types a new URL, closes the tab) instead of
 * explicitly closing it first, our own close() never fires, so the "hidden"
 * state follows them to every subsequent page until something resets it.
 * Since no panel of ours can ever be open at the moment a fresh page starts
 * loading, we unconditionally set it back to visible once here on init,
 * regardless of what a previous page may have left behind.
 */
(function () {
  if (window.__shIntercomGuardInit) return;
  window.__shIntercomGuardInit = true;

  var openCount = 0;

  function setLauncherHidden(hidden) {
    if (typeof window.Intercom !== 'function') return;
    window.Intercom('update', { hide_default_launcher: hidden });
  }

  window.shIntercomGuard = {
    open: function () {
      openCount += 1;
      if (openCount === 1) setLauncherHidden(true);
    },
    close: function () {
      openCount = Math.max(0, openCount - 1);
      if (openCount === 0) setLauncherHidden(false);
    }
  };

  setLauncherHidden(false);

  document.addEventListener('dialog:after-show', window.shIntercomGuard.open, true);
  document.addEventListener('dialog:after-hide', window.shIntercomGuard.close, true);
})();
